import { Controller } from "@hotwired/stimulus";

// TODO:
// Make images optional
// Fix secondary up down arrow
// Rename this, it's not just for instructors

var cachedApiCalls = {};
var cacheDeletionTimes = {};

setInterval(() => {
  const now = Date.now();
  for (const key in cacheDeletionTimes) {
    if (cacheDeletionTimes[key] < now) {
      delete cachedApiCalls[key];
      delete cacheDeletionTimes[key];
    }
  }
}, 5 * 1000);

export default class extends Controller {
  static targets = [
    "currentItemWrapper",
    "currentItemName",
    "currentInstructorImage",
    "dropdown",
    "searchContainer",
    "searchInput",
    "instructorOutOfZoneDropdown",
    "instructorOutOfZoneDropdownArrow",
    "defaultImage",
    "primaryItems",
    "secondaryItems",
    "itemTemplate",
    "loader",
  ];

  // Properties that track the current display properties of the UI
  areItemsExpanded = false;
  areSecondaryItemsExpanded = false;
  searchTerm = "";
  preFilterTerm = "";
  hasInteractedWith = false;

  itemsChanged = false;
  items = [];
  secondaryItems = [];
  isLoading = true;
  hasDoneFirstApiCall = false;

  connect() {
    // data-driving-school-widgets-instructor-selector-async-additional-params-query-selectors
    const x = this.data.get("additionalParamsQuerySelectors");

    // When the widget is first initialised, we should make sure the default item is broadcast as selected
    // to ensure that the desired selection behaviour on any parent components is triggered
    // set in a timeout so the event is not triggered before the parent component has had a chance to listen for it
    setTimeout(() => {
      const id = this.currentItemWrapperTarget.dataset.instructorId;
      const inputQuerySelector = this.data.get("inputQuerySelector");
      const inputElement = document.querySelector(inputQuerySelector);
      inputElement.value = id;
      inputElement.dispatchEvent(new Event("input"));
      inputElement.dispatchEvent(new Event("change"));
      this.filter({
        currentTarget: {
          value: "",
        },
      });

      this.addListenersToExtraParamInputs();
    });
  }

  filterId = null;
  /**
   * Triggered when the user types
   * @param {*} event
   */
  filter(event) {
    const searchTerm = event.currentTarget.value;

    console.log("Filtering with term:", searchTerm);
    console.log("Previous search term:", this.searchTerm);
    console.log("Has done first API call:", this.hasDoneFirstApiCall);

    if (searchTerm === this.searchTerm && this.hasDoneFirstApiCall) {
      return;
    }

    const randomId = Math.random().toString(36).substring(2, 15);
    this.filterId = randomId;
    setTimeout(() => {
      this.respondToFilter(randomId, searchTerm);
    }, 1500);

    this.isLoading = true;
    this.items = [];
    this.secondaryItems = [];
    this.itemsChanged = true;
    this.setDisplayProperties();
  }

  /**
   * Triggered when the user clicks on an item
   * @param {*} event
   * @param {*} interact
   */
  selectItem(event) {
    const id = event.currentTarget.dataset.instructorId;
    const name = event.currentTarget.dataset.instructorName;
    const image = event.currentTarget.getElementsByTagName("img")[0].src;

    this.currentItemWrapperTarget.dataset.instructorId = id;
    this.currentItemNameTarget.innerHTML = name;
    this.currentInstructorImageTarget.src = image;

    this.closeSelection();

    const inputQuerySelector = this.data.get("inputQuerySelector");
    const inputElement = document.querySelector(inputQuerySelector);

    const nameQuerySelector = this.data.get("nameQuerySelector");
    if (nameQuerySelector) {
      const nameElement = document.querySelector(nameQuerySelector);
      if (nameElement) {
        nameElement.innerHTML = name;
      }
    }

    inputElement.value = id;
    // TODO: Should this always do this?
    inputElement.dispatchEvent(new Event("input"));
    inputElement.dispatchEvent(new Event("change"));
  }

  /**
   * Used to expand/collapse the items list
   * @param {*} event
   */
  toggleSelection(event) {
    this.areItemsExpanded = !this.areItemsExpanded;
    this.setDisplayProperties();
  }

  /**
   * Used to expand/collapse the secondary items list
   * @param {*} event
   */
  toggleSecondarySelection() {
    this.areSecondaryItemsExpanded = !this.areSecondaryItemsExpanded;
    this.setDisplayProperties();
  }

  /**
   * Triggered when the user is done typing, decides whether to make a call to the items URLs
   * @param {*} filterId
   * @returns
   */
  async respondToFilter(filterId, searchTerm) {
    if (this.filterId !== filterId) {
      return;
    }

    this.hasDoneFirstApiCall = true;
    this.searchTerm = searchTerm;
    const response = await this.makeCallToItemsUrl();

    if (this.filterId !== filterId) {
      return;
    }

    this.items = response.results;
    this.secondaryItems = response.secondaryResults;
    this.itemsChanged = true;
    this.secondaryItems = response.secondaryResults;
    this.isLoading = false;
    this.setDisplayProperties();
  }

  /**
   * Goes to the items URL and fetches the items based on the search term
   * and the filter value (if any).
   * @returns
   */
  makeCallToItemsUrl() {
    const itemsUrl = this.data.get("url");
    const additionalParamsQuerySelectors = this.data
      .get("additionalParamsQuerySelectors")
      .split(" ");
    const additionalParams = {};
    additionalParamsQuerySelectors
      .filter((x) => x)
      .forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          const paramName = element.dataset.paramName;
          additionalParams[paramName] = element.value;
        }
      });

    const searchInput = this.searchInputTarget.value;
    const filterQuerySelector = this.data.get("filterQuerySelector");
    let filterValue = "";
    if (filterQuerySelector) {
      const filterElement = document.querySelector(filterQuerySelector);
      if (filterElement) {
        filterValue = filterElement.value;
      }
    }

    const url = `${itemsUrl}?search=${searchInput}&filter=${filterValue}`;
    const cacheKey = `${url}-${JSON.stringify(additionalParams)}`;

    if (cachedApiCalls[cacheKey]) {
      return cachedApiCalls[cacheKey];
    } else {
      const promise = new Promise((resolve, reject) => {
        // Make the post call
        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
              .content,
          },
          body: JSON.stringify({
            search: searchInput,
            filter: filterValue,
            ...additionalParams,
          }),
        })
          .then((response) => {
            resolve(response.json());
          })
          .catch((error) => {
            console.error("Error fetching items:", error);
            resolve({
              success: false,
              message: "Was unable to fetch items.",
              results: [],
              secondaryResults: [],
            });
          });
      });
      // Cache it
      cachedApiCalls[cacheKey] = promise;
      // Delete after 5 mins
      cacheDeletionTimes[cacheKey] = Date.now() + 0.5 * 60 * 1000;
      return promise;
    }
  }

  closeSelection() {
    this.areItemsExpanded = false;
    this.setDisplayProperties();
  }

  /**
   * Uses the state of the controller to update the html elements
   * to reflect the current state of the controller.
   */
  setDisplayProperties() {
    if (this.itemsChanged) {
      this.itemsChanged = false;
      // Clear the primary items target
      this.primaryItemsTarget.innerHTML = "";
      // Use itemTemplate to populate the primary items target

      this.items.forEach((item) => {
        const node = this.itemTemplateTarget.content.cloneNode(true);
        const itemElement = node.querySelector(".instructor-card-wrapper");

        itemElement.dataset.instructorId = item.id;
        itemElement.dataset.dispatchItem = JSON.stringify(item);
        itemElement.dataset.filterTag = item.filterTag;
        itemElement.dataset.instructorName = item.name;
        itemElement.dataset.instructorImage = item.image;
        itemElement.classList.add("primary-item");

        itemElement.style.height = "auto"; // Set height to 50px for visibility
        itemElement.classList.remove("u-hidden");

        const itemName = itemElement.querySelector(".instructor-name");
        itemName.innerHTML = item.name;

        (item.subtitles || []).forEach((subtitle) => {
          const subtitleElement = document.createElement("p");
          subtitleElement.classList.add("m0");
          subtitleElement.classList.add("u-italic");
          subtitleElement.innerHTML = subtitle;
          // Get the parent of itemName
          itemName.parentNode.appendChild(subtitleElement);
        });

        const itemImage = itemElement.querySelector("img");
        itemImage.src = item.image || this.defaultImageTarget.src;
        this.primaryItemsTarget.appendChild(itemElement);
      });

      // Clear the secondary items target
      this.secondaryItemsTarget.innerHTML = "";
      // Use itemTemplate to populate the secondary items target
      this.secondaryItems.forEach((item) => {
        const node = this.itemTemplateTarget.content.cloneNode(true);
        const itemElement = node.querySelector(".instructor-card-wrapper");

        itemElement.dataset.instructorId = item.id;
        itemElement.dataset.dispatchItem = JSON.stringify(item);
        itemElement.dataset.filterTag = item.filterTag;
        itemElement.dataset.instructorName = item.name;
        itemElement.dataset.instructorImage = item.image;
        itemElement.classList.add("secondary-items");

        itemElement.style.height = "auto"; // Set height to 50px for visibility
        itemElement.classList.remove("u-hidden");

        const itemName = itemElement.querySelector(".instructor-name");
        itemName.innerHTML = item.name;

        (item.subtitles || []).forEach((subtitle) => {
          const subtitleElement = document.createElement("p");
          subtitleElement.classList.add("m0");
          subtitleElement.classList.add("u-italic");
          subtitleElement.innerHTML = subtitle;
          // Get the parent of itemName
          itemName.parentNode.appendChild(subtitleElement);
        });

        const itemImage = itemElement.querySelector("img");
        itemImage.src = item.image || this.defaultImageTarget.src;
        this.secondaryItemsTarget.appendChild(itemElement);
      });
    }

    const showLoader = this.areItemsExpanded && this.isLoading;
    if (showLoader) {
      this.loaderTarget.classList.remove("u-hidden");
    } else {
      this.loaderTarget.classList.add("u-hidden");
    }

    const showSearch = this.areItemsExpanded;
    this.searchContainerTarget.style.height = showSearch ? "auto" : "0px";
    if (showSearch) {
      this.searchContainerTarget.classList.remove("u-hidden");
    } else {
      this.searchContainerTarget.classList.add("u-hidden");
    }
    const rotateDropdown = this.areItemsExpanded;
    this.dropdownTarget.style.transform = rotateDropdown
      ? "rotate(180deg)"
      : "rotate(360deg)";

    const rotateOutOfZoneDropdown = this.areInstructorsOutOfZoneExpanded;
    this.instructorOutOfZoneDropdownArrowTarget.style.transform =
      rotateOutOfZoneDropdown ? "rotate(180deg)" : "rotate(360deg)";

    const showSecondaryDropdown = this.areItemsExpanded;
    this.instructorOutOfZoneDropdownTarget.style.height = showSecondaryDropdown
      ? "30px"
      : "0px";

    const showOutOfZoneInstructors =
      this.areItemsExpanded && this.areSecondaryItemsExpanded;
    const outOfZoneInstructors =
      this.element.getElementsByClassName("secondary-items");

    let outOfZoneCount = 0;
    for (let i = 0; i < outOfZoneInstructors.length; i++) {
      const element = outOfZoneInstructors[i];
      const instructorName = element.dataset.instructorName;
      const filterTag = element.dataset.filterTag;
      // const showThisInstructor =
      //   instructorName.toLowerCase().includes(this.searchTerm.toLowerCase()) &&
      //   (!this.preFilterTerm || filterTag == this.preFilterTerm);
      const showThisInstructor = true; // TODO: Remove this line, it's just for testing
      outOfZoneCount += showThisInstructor ? 1 : 0;
      element.style.height =
        showOutOfZoneInstructors && showThisInstructor ? "auto" : "0px";
      if (showOutOfZoneInstructors && showThisInstructor) {
        element.classList.remove("u-hidden");
      } else {
        element.classList.add("u-hidden");
      }
    }

    if (outOfZoneCount === 0 && this.hasInstructorOutOfZoneDropdownTarget) {
      this.instructorOutOfZoneDropdownTarget.classList.add("u-hidden");
    } else {
      this.instructorOutOfZoneDropdownTarget.classList.remove("u-hidden");
    }

    const showInZoneInstructors = this.areItemsExpanded;
    const inZoneInstructors =
      this.element.getElementsByClassName("primary-item");
    for (let i = 0; i < inZoneInstructors.length; i++) {
      const element = inZoneInstructors[i];
      const instructorName = element.dataset.instructorName;
      const showThisInstructor = true; // TODO: Remove this line, it's just for testing
      element.style.height =
        showInZoneInstructors && showThisInstructor ? "auto" : "0px";
      if (showInZoneInstructors && showThisInstructor) {
        element.classList.remove("u-hidden");
      } else {
        element.classList.add("u-hidden");
      }
    }
  }

  addListenersToExtraParamInputs() {
    const additionalParamsQuerySelectors = this.data
      .get("additionalParamsQuerySelectors")
      .split(" ");

    const inputs = additionalParamsQuerySelectors
      .filter((x) => x)
      .map((selector) => document.querySelector(selector))
      .filter((element) => element);

    const callBack = () => {
      const searchTerm = this.searchInputTarget.value;
      const randomId = Math.random().toString(36).substring(2, 15);
      this.filterId = randomId;

      setTimeout(() => {
        this.respondToFilter(randomId, searchTerm);
      }, 1500);

      this.isLoading = true;
      this.items = [];
      this.secondaryItems = [];
      this.itemsChanged = true;
      this.setDisplayProperties();
    };

    inputs.forEach((input) => {
      input.addEventListener("change", () => {
        callBack();
      });

      input.addEventListener("input", () => {
        callBack();
      });
    });
  }
}
